import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { NAV } from "../data/content";

export const NavDock = ({ active, onNavigate }) => {
  const [hovered, setHovered] = useState(null);

  return (
    <motion.nav
      data-testid="nav-dock"
      initial={{ y: 120, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.6, duration: 1, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-5 left-1/2 z-[999] -translate-x-1/2"
    >
      <div className="glass flex items-center gap-1 rounded-full px-2 py-2 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.9)]">
        {NAV.map((item) => {
          const isActive = active === item.id;
          return (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => onNavigate(item.id)}
              onMouseEnter={() => setHovered(item.id)}
              onMouseLeave={() => setHovered(null)}
              className="relative rounded-full px-3 py-2 text-[0.72rem] font-medium uppercase tracking-wider transition-colors sm:px-4"
              style={{ color: isActive ? "rgb(var(--ink))" : "rgb(var(--cream) / 0.65)" }}
            >
              {isActive && (
                <motion.span
                  layoutId="nav-pill"
                  className="absolute inset-0 rounded-full bg-cream"
                  transition={{ type: "spring", stiffness: 400, damping: 34 }}
                />
              )}
              {hovered === item.id && !isActive && (
                <motion.span
                  layoutId="nav-hover"
                  className="absolute inset-0 rounded-full bg-white/8"
                  transition={{ type: "spring", stiffness: 400, damping: 34 }}
                />
              )}
              <span className="relative z-10">{item.label}</span>
            </button>
          );
        })}
      </div>
    </motion.nav>
  );
};
